export const isDefined = <T>(value: T | undefined | null): value is T => {
  return (value as T) !== undefined && (value as T) !== null
}
